/**
 * Semantic CSS class registry for default business email templates.
 * Theme engine (EmailCssService) styles these classes; templates use class-only markup.
 */
import { EMAIL_THEME_CONTENT_SECTION_LEGACY_ALIASES, } from './emailSectionGroups.js';
export const EMAIL_THEME_CLASS_REGISTRY = {
    shell: [
        'body',
        'container',
        'header',
        'content',
        'footer',
        'email-footer',
        'layout-footer-note',
        'header-logo-wrap',
        'header-logo',
    ],
    buttons: ['cta-button', 'secondary-button'],
    /** Legacy aliases — theme engine maps to cta-button rules */
    buttonAliases: ['track-button', 'review-button', 'statement-pay-button'],
    sections: [
        'content-section',
        'items-section',
        'cta-section',
        'payment-section',
        'pricing-section',
        'amount-due-section',
        'due-date',
        'schedule-section',
        'thank-you-section',
        'technician-section',
        'review-section',
        'tracking-section',
        'contact-section',
        'welcome-message',
        'next-steps',
        'validity-notice',
        'security-note',
        'reminder-message',
        'alert-box',
        'message-box',
        'summary-box',
        'schedule-change',
        'amount-section',
        'payment-options',
        'greeting',
        ...EMAIL_THEME_CONTENT_SECTION_LEGACY_ALIASES,
    ],
    cards: [
        'estimate-card',
        'invoice-card',
        'deposit-card',
        'payment-card',
        'job-card',
        'success-card',
        'customer-card',
        'eta-card',
        'location-card',
        'info-card',
    ],
    typography: [
        'detail-row',
        'detail-label',
        'detail-value',
        'detail-item',
        'amount-label',
        'amount-value',
        'info-label',
        'info-value',
        'info-item',
        'info-row',
        'option-name',
        'option-description',
        'option-price',
        'estimate-number',
        'estimate-title',
        'estimate-subtitle',
        'invoice-number',
        'invoice-title',
        'job-number',
        'job-title',
        'schedule-label',
        'schedule-value',
        'schedule-time',
        'schedule-new',
        'payment-label',
        'payment-amount',
        'step',
        'step-number',
        'step-title',
        'step-description',
        'success-badge',
        'success-icon',
        'success-title',
        'success-message',
    ],
    status: ['validity-notice', 'due-date', 'alert-box', 'reminder-message', 'security-note'],
    tables: ['jobs-table', 'summary-table'],
    utilities: ['text-center', 'section-tight', 'section-spaced'],
};
export const EMAIL_THEME_ALL_CLASSES = Object.values(EMAIL_THEME_CLASS_REGISTRY).flat();
/** Section classes that receive sectionGap spacing from theme */
export const EMAIL_THEME_SECTION_GAP_CLASSES = EMAIL_THEME_CLASS_REGISTRY.sections;
/** Card classes that receive card radius / border / background from theme */
export const EMAIL_THEME_CARD_CLASSES = EMAIL_THEME_CLASS_REGISTRY.cards;
//# sourceMappingURL=emailThemeClassRegistry.js.map